const PENDING_REFERRAL_KEY = "pending_referral_code";

/**
 * Capture ?ref= URL parameter on app load.
 * Stores the code in localStorage and cleans the URL.
 */
export const captureReferralParam = () => {
  const params = new URLSearchParams(window.location.search);
  const refCode = params.get("ref");
  if (refCode) {
    localStorage.setItem(PENDING_REFERRAL_KEY, refCode.trim().toUpperCase());
    params.delete("ref");
    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;
    window.history.replaceState({}, "", newUrl);
  }
};

/**
 * Get stored pending referral code (null if none).
 */
export const getPendingReferralCode = () => {
  return localStorage.getItem(PENDING_REFERRAL_KEY);
};

/**
 * Clear the pending referral code after successful redemption.
 */
export const clearPendingReferralCode = () => {
  localStorage.removeItem(PENDING_REFERRAL_KEY);
};
